import { makeAutoObservable } from "mobx"

const theme = {
  Wealth: {
    key: "Wealth",
  },
  Retirement: {
    key: "Retirement",
  },
  Child: {
    key: "Child",
  },
}

class FormStore {
  calc_type = theme["Wealth"] // Retirement, Child
  calc_buyingFor = "Self"
  calc_gender = "Male"
  calc_age = ""
  calc_dob = ""
  calc_phone = ""
  calc_email = ""
  calc_annual = ""
  calc_checkOne = true
  calc_checkTwo = false
  calc_clickOne = false
  calc_clickTwo = true
  calc_eligibilityTab = 0
  calc_charges = 0
  calc_ChildName = "Your child"

  calc_aiModal = false
  calc_mobModal = false
  calc_suitability = false
  calc_pagescrn = "first"

  quote_modal = false // Quote Page
  quote_modalLoader = true // Quote Loader // MinMax Range For Life Cover Dependent
  quote_cardLoader = false
  quote_shouldUpdate = false // Factor for PolicyTerm Refresh // SWP Restore
  quote_shouldUpdateFunds = false // useEffect in QuoteInvest Runs two way binding upating selected funds. // Wait, But thats illegal //
  quote_invest = 3750
  quote_policyTerm = 64 - this.calc_age   // 20     //Pragati_08-04
  quote_every = "Monthly"
  quote_paymentFreq = "Regular"
  quote_payFor = 10
  quote_lifeCover = this.quote_invest * (this.calc_age > 45 ? 1.25 : 10) * 12;
  quote_arr = 8

  quote_investStrat = "Aggressive"
  quote_investStratExpand = false
  quote_investStratTT = false
  quote_investFundSelected = []

  quote_editFunds = false // Funds Mode
  quote_fundsTab = 0
  quote_fundsTabGrp = []
  quote_fundsBaseData = []
  // quote_fundsDataSourceTabGrp = EditFund["filter"] // All, Equity...
  // quote_fundsDataSourceTabs = EditFund["filter"].filter((x) => x.type.includes(1)) // Age, Assets, Portfolio...
  quote_TotalPercen = 100

  quote_fundStrategyTitle = "You can decide % allocation you want to give within 15 funds. Don't worry, you have unlimited fund switches."
  quote_cardOneRadio = "N" // Two Card Radio // SWP
  quote_cardTwoRadio = "N" // Two Card Radio // ATS

  quote_paymentMode = "Monthly"
  quote_paymentDate = "1"

  quote_from = "" // TODO
  quote_to = "Blue chip Fund"
  quote_dot = "1"
  quote_transferAmount = 8000
  quote_cardTwoCheckBox = false

  quote_checkOne = true
  quote_checkTwo = false
  quote_checkThree = true

  api_8percentage = 0
  api_4percentage = 0
  api_8percentageOFFLINE = 0
  api_4percentageOFFLINE = 0
  api_fundPerformData_UNTOUCHED = []
  api_fundPerformData = []

  persona_Validity = false // Value = False For Dynmaic With Changes in App.js

  story_Type = ""
  
  constructor() {
    makeAutoObservable(this)
  }

  setCalcType = (data) => (this.calc_type = theme[data])
  setCalcBuyingFor = (data) => (this.calc_buyingFor = data)
  setCalcGender = (data) => (this.calc_gender = data)
  setCalcAnualIncome = (data) => (this.calc_annual = data)
  setCalcDob = (data) => (this.calc_dob = data)
  setCalcAge = (data) => (this.calc_age = data)
  setCalcPhone = (data) => (this.calc_phone = data)
  setCalcEmail = (data) => (this.calc_email = data)
  setCalcCheckOne = (data) => (this.calc_checkOne = data)
  setCalcCheckTwo = (data) => (this.calc_checkTwo = data)
  setCalcClickOne = (data) => (this.calc_clickOne = data)
  setCalcClickTwo = (data) => (this.calc_clickTwo = data)
  setCalcEligibility = (data) => (this.calc_eligibilityTab = data)
  setCalcCharges = (data) => (this.calc_charges = data)
  setCalcName = (data) => (this.calc_ChildName = data)

  setAIModal = (data) => (this.calc_aiModal = data)
  setMobileModal = (data) => (this.calc_mobModal = data)
  setSuitabilityModal = (data) => (this.calc_suitability = data)
  setCalcPageScrn = (data) => (this.calc_pagescrn = data)

  setQuoteModal = (data) => (this.quote_modal = data)
  setQuoteModalLoader = (data) => (this.quote_modalLoader = data)
  setQuoteCardLoader = (data) => (this.quote_cardLoader = data)
  setQuoteShouldUpdate = (data) => (this.quote_shouldUpdate = data)
  setQuoteShouldUpdateFunds = (data) => (this.quote_shouldUpdateFunds = data)
  setInvest = (data) => (this.quote_invest = data)
  setPolicyTerm = (data) => (this.quote_policyTerm = Number(data))
  setEvery = (data) => (this.quote_every = data)
  setPaymentFreq = (data) => (this.quote_paymentFreq = data)
  setPayFor = (data) => (this.quote_payFor = data)

  setLifeCover = (data) => (this.quote_lifeCover = data)
  setARR = (data) => (this.quote_arr = data)

  setInvestStrat = (data) => (this.quote_investStrat = data)
  setInvestStratExpand = (data) => (this.quote_investStratExpand = data)
  setInvestStratTT = (data) => (this.quote_investStratTT = data)
  setInvestFundSelected = (data) => {
    this.quote_investFundSelected = data
    window.UserInput.selectedFunds = [...data]
  }

  setEditFundsMode = (data) => (this.quote_editFunds = data)
  setFundsBaseData = (data) => (this.quote_fundsBaseData = data)

  setFundsTabGrp = (data) => {
    this.quote_fundsTabGrp = data
    this.setFundsDataSourceTabGrp(data)
  }
  setFundsTotalPercen = (data) => (this.quote_TotalPercen = data)

  setFundsDataSourceTabGrp = (data) => (this.quote_fundsDataSourceTabGrp = data)
  setFundsDataSourceTabs = (data) => (this.quote_fundsDataSourceTabs = data)

  setCardOneRadio = (data) => (this.quote_cardOneRadio = data)
  setCardTwoRadio = (data) => (this.quote_cardTwoRadio = data)

  setPaymentMode = (data) => (this.quote_paymentMode = data)
  setPaymentDate = (data) => (this.quote_paymentDate = data)

  setQuoteFrom = (data) => (this.quote_from = data)
  setQuoteTo = (data) => (this.quote_to = data)
  setQuoteDOT = (data) => (this.quote_dot = data)

  setTransferAmount = (data) => (this.quote_transferAmount = data)
  setCardTwoCheckBox = (data) => (this.quote_cardTwoCheckBox = data)

  setQuoteFundStrategyTitle = (data) => (this.quote_fundStrategyTitle = data)
  setQuoteCheckOne = (data) => (this.quote_checkOne = data)
  setQuoteCheckTwo = (data) => (this.quote_checkTwo = data)
  setQuoteCheckThree = (data) => (this.quote_checkThree = data)

  setAPI8Percentage = (data) => (this.api_8percentage = data)
  setAPI4Percentage = (data) => (this.api_4percentage = data)
  setAPI8PercentageOFFLINE = (data) => (this.api_8percentageOFFLINE = data)
  setAPI4PercentageOFFLINE = (data) => (this.api_4percentageOFFLINE = data)

  setAPIFundPerform = (data) => (this.api_fundPerformData = data)
  setAPIFundPerform_UNTOUCHED = (data) => (this.api_fundPerformData_UNTOUCHED = data)

  setPersonaValidity = (data) => (this.persona_Validity = data)
  
  setStoryType = (data) => (this.story_Type = data)
}

export default new FormStore()
